import { merchants, uniqueStores } from "helpers/stores";
import { Logos, Logo, Icon } from "./StoreLogos.styled";

export default function StoreLogos() {
    return (
        <Logos>
            {uniqueStores(merchants)?.map(brand => (
                <Logo key={brand.id}>
                    <Icon
                        src={brand?.image?.white}
                        alt={`${brand.id} logo`}
                        loading="lazy"
                        width={120}
                        height={25}
                    />
                </Logo>
            ))}
        </Logos>
    );
}
